import type { SpotlightContent, SpotlightLink } from '~kui/components/KUI/Unified/Spotlight/KUIUnifiedSpotlight.vue';

/**
 * A spotlight the completion shows. Finishing a collection's last activity can earn two, the
 * activity's own and the collection's, so each carries a key its link clicks are reported under.
 */
export interface CompletionSpotlight extends SpotlightContent {
  key: string;
}

export interface CompletionSpotlightLinkClick {
  key: string;
  link: SpotlightLink;
}

export interface CompletionPrize {
  title: string;
  isUserEligible: boolean;
  /** Game-of-skill question the entrant must answer; null when the campaign has none. */
  skillQuestion?: string | null;
}

export const PRIZE_OUTCOME = {
  Confirmed: 'confirmed',
  PhoneSkipped: 'phoneSkipped',
  Cancelled: 'cancelled',
} as const;

export type PrizeOutcome = (typeof PRIZE_OUTCOME)[keyof typeof PRIZE_OUTCOME] | null;
